<template>
  <div class="flex flex-col font-sans pb-6 mb-1 mx-auto">

    <div class="mt-10 flex-row text-lg mb-6 items-center justify-between hidden md:flex relative">
      <div class="flex w-full">
        <div class="flex flex-row mr-1 xmd:mr-2 lg:mr-8">
          <router-link to="/partners/events"
                       class="outline-none no-underline font-bold md:text-xm xmd:text-base lg:text-base-lg xlg:text-xl text-main-text">
            Ближайшие игры
          </router-link>
        </div>
        <div class="flex flex-row mr-1 xmd:mr-2 lg:mr-8">
          <router-link to="/partners/registration"
                       class="outline-none no-underline font-bold md:text-xm xmd:text-base lg:text-base-lg xlg:text-xl text-main-text">
            Текущая регистрация
          </router-link>
        </div>
        <div class="flex flex-row mr-1 xmd:mr-2 lg:mr-8">
          <router-link to="/partners/data-base"
                       class="outline-none no-underline font-bold md:text-xm xmd:text-base lg:text-base-lg xlg:text-xl text-main-text"
                       v-if="user.role !== 'event_organizer'">
            База данных
          </router-link>
        </div>
        <div class="flex flex-row mr-1 xmd:mr-2 lg:mr-8">
          <router-link to="/partners/news"
                       class="outline-none no-underline font-bold md:text-xm xmd:text-base lg:text-base-lg xlg:text-xl text-main-text"
                       v-if="user.role === 'editor' && user.role !== 'event_organizer'">
            Что нового
          </router-link>
        </div>
        <div class="flex flex-row" v-if="user.role !== 'player'">
          <a href="https://lk.mozgo.com/"
                        class="outline-none no-underline font-bold md:text-xm xmd:text-base lg:text-base-lg xlg:text-xl text-main-text"
                        target="blank"
                        v-if="user.role !== 'event_organizer'">

            Лицензионный комплекс
          </a>
        </div>
      </div>


      <form action.prevent="" class="flex flex-row w-auto justify-end z-20 choose-city pin-r">
        <citySelectbox
            :is_city="true"
            v-if="cities"
            placeholder="Выбрать город"
            class="font-bold  whitespace-no-wrap w-full text-lg z-50"
            @itemSelected="chooseCity"
            :cityIsOnlyOne="Object.keys(cities).length<1"
            v-bind:list-items="cities" v-model="form.id"></citySelectbox>
      </form>
    </div>
    <form action.prevent="" class="flex flex-row w-auto justify-end md:hidden mt-6">
      <citySelectbox
          :is_city="true"
          v-if="cities"
          placeholder="Выбрать город"
          class="font-bold text-xs whitespace-no-wrap w-full  z-30"
          @itemSelected="chooseCity"
          :cityIsOnlyOne="Object.keys(cities).length<1"
          v-bind:list-items="cities" v-model="form.id"></citySelectbox>
    </form>
    <ClientNav
        @closeOther="closeSelectAdditional"
        ref="options"
        key="options"
        class="mt-4 md:hidden z-10"
        :options="options"/>

    <div v-if="$route.name=='registration' || $route.name=='data-base'" class="flex flex-col mt-6">
      <div class="flex w-full justify-end">
        <div class="rounded border relative md:flex flex-row w-64 hidden "
             :class="searchFocus? 'border-brand-light':'border-additional-text'">
          <input v-model="like" ref="searchLike" class="rounded py-2 pr-2 pl-3 outline-none" type="text"
                 @focus.stop="searchFocus=true"
                 @blur.stop="searchFocus=false">
          <img v-if="!like" class="mr-4 mt-2 absolute pin-r h-4 w-4" src="@/assets/SVG/looppa.svg"/>
          <img v-else
               @click="like=''; $refs.searchLike.focus()"
               class="m-3 absolute pin-r h-2 w-2 cursor-pointer"
               src="@/assets/SVG/cross-partners.svg"/>
        </div>
      </div>
    </div>
    <div class="md:flex flex-row justify-between w-full mt-9 hidden"
         v-if="($route.name === 'events' || $route.name === 'places' || $route.name === 'season') && this.user.role !== 'event_organizer'">
      <!--<div class="font-bold text-base-lg xlg:text-xl">{{title}}</div>-->
      <div class="flex flex-row font-bold md:text-xm xmd:text-base lg:text-base-lg xlg:text-xl">
        <router-link :to="{name: 'events'}"
                     class="text-main-text no-underline">
          Календарь мероприятий
        </router-link>
        <router-link :to="{name: 'places'}"
                     class="text-main-text no-underline ml-12">
          Заведения
        </router-link>
        <router-link :to="{name: 'season'}"
                     v-if="user.is_able_to_change_season"
                     class="text-main-text no-underline ml-12">
          Управление сезонами
        </router-link>

      </div>

    </div>
    <ClientNav
        @closeOther="closeSelectOption"
        ref="additionalOptions"
        key="additionalOptions"
        v-if="$route.name === 'events' || $route.name === 'places' || $route.name === 'season'"
        class="mt-4 md:hidden"
        :options="optionEvents"/>
    <NewsHandler :url="'/api/portal/news'" :type="'Partner'"/>
    <stat-notification v-if="cityId && waitingStatistics" :city-id="cityId" :waiting-statistics="waitingStatistics"/>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import client from '@/clients/partners';
import Form from 'form-backend-validation';
import debounce from 'lodash/debounce';
import clone from 'lodash/cloneDeep';
import citySelectbox from './city-selectbox.vue';
import LogoutModal from '../../helpers/logout-modal.vue';
import UserModal from '../../helpers/user-modal.vue';
import onClickOutside from '@/views/OnClickOutside';
import ClientNav from '../players/user-nav-mobile';
import NewsHandler from './news/newsHandler';
import StatNotification from '@/views/partners/current-registration/stat-layout/stat-modal/statNotification';

export default {
  name: 'menuOrder',
  components: {
    StatNotification,
    LogoutModal,
    citySelectbox,
    UserModal,
    onClickOutside,
    ClientNav,
    NewsHandler,
  },
  data() {
    return {
      cities: '',
      options: {
        0: { name: 'Ближайшие игры', link: '/partners/events/events', type: 'events' },
        1: { name: 'Текущая регистрация', link: '/partners/registration', type: 'registration' },
        2: { name: ' База данных', link: '/partners/data-base-mobile', type: 'data-base-mobile' },
      },
      optionEvents: {
        1: { name: 'Заведения', link: '/partners/events/places', type: 'places' },
        0: { name: 'Календарь мероприятий', link: '/partners/events/events', type: 'events' },
        2: { name: 'Управление сезонами', link: '/partners/events/season', type: 'season' },

      },
      like: this.$route.query.like || '',
      form: new Form({
        id: '',
      }, { http: client }),
      searchFocus: false,
    };
  },
  created() {
    client.get('/cities')
      .then(({ data: { data: cities } }) => {
        this.cities = { ...cities };
        this.getIsActive();
        this.$store.cityId = this.form.id;
        this.setPartnerCityObject(cities[this.form.id]);
      });
    if (this.user.role === 'editor') {
      this.options[3] = { name: ' Что нового', link: '/partners/news', type: 'news' };
    }
  },
  mounted() {
    if (this.like.length) {
      this.$refs.searchLike.focus();
    }
  },
  methods: {
    ...mapActions(['refreshUser', 'setPartnerCityObject']),
    getIsActive() {
      for (const key in this.cities) {
        if (this.cities[key].is_active) {
          this.form.id = key;
        }
      }
    },

    closeSelectAdditional() {
      if (this.$refs.additionalOptions && this.$refs.additionalOptions.showFilter) {
        this.$refs.additionalOptions.close();
      }
    },
    closeSelectOption() {
      if (this.$refs.options.showFilter) {
        this.$refs.options.close();
      }
    },
    chooseCity() {
      client.patch(`/active/${this.form.id}`)
        .then(() => {
          this.refreshUser(client);
        });
    },
    newSearch: debounce(function (like) {
      const query = clone(this.$route.query);
      query.like = like;
      query.page = 1;
      const searchQuery = {};
      for (const key in query) {
        if (query[key] === '') {
          continue;
        }
        searchQuery[key] = query[key];
      }
      this.$router.push({ query: searchQuery });
    }, 1400),
  },
  computed: {
    ...mapState({
      cityId: state => state.auth.user.city_id,
      waitingStatistics: state => state.auth.waitingStatistics,
    }),
    user() {
      return this.$store.getters.userInfo;
    },
    title() {
      if (this.$route.name === 'events') {
        return 'Календарь мероприятий';
      }
      if (this.$route.name === 'places') {
        return 'Ваши заведения';
      }
      if (this.$route.name === 'season') {
        return 'Управление сезонами';
      }
      return '';
    },
  },
  watch: {
    like(val) {
      this.newSearch(val);
    },
  },
};
</script>

<style scoped lang="less">

.router-link-active {
  @apply .border-b-2 .border-yellow;
}


  .choose-city {
    position: absolute;
    margin-top: -3.5rem;

}
</style>
